import { useState } from 'react';
import Button from '@/components/ui/Button';

const QUICK_PROMPTS = [
  'Something light for a hot day',
  'Bold red for a braai',
  'Crisp white for seafood',
  'Something special for a celebration',
  'Easy-drinking everyday red',
];

interface RecommendPromptProps {
  onSubmit: (prompt: string, context: 'CELLAR' | 'BUY') => void;
  loading?: boolean;
}

export default function RecommendPrompt({ onSubmit, loading = false }: RecommendPromptProps) {
  const [prompt, setPrompt] = useState('');
  const [context, setContext] = useState<'CELLAR' | 'BUY'>('BUY');

  function submit(text: string) {
    if (!text.trim()) return;
    onSubmit(text.trim(), context);
  }

  return (
    <div className="recommend-prompt">
      <div className="recommend-context-toggle">
        <button
          className={`context-btn ${context === 'BUY' ? 'active' : ''}`}
          onClick={() => setContext('BUY')}
        >
          Suggest wines to buy
        </button>
        <button
          className={`context-btn ${context === 'CELLAR' ? 'active' : ''}`}
          onClick={() => setContext('CELLAR')}
        >
          From my cellar
        </button>
      </div>

      <div className="recommend-input-row">
        <textarea
          className="recommend-textarea"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="What are you in the mood for? e.g. &quot;something bold for a braai tonight&quot;"
          rows={3}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(prompt); }
          }}
        />
        <Button variant="primary" onClick={() => submit(prompt)} loading={loading} disabled={!prompt.trim()}>
          Go
        </Button>
      </div>

      <div className="quick-prompts">
        {QUICK_PROMPTS.map((p) => (
          <button key={p} className="quick-prompt-chip" onClick={() => submit(p)}>
            {p}
          </button>
        ))}
      </div>
    </div>
  );
}
